module.exports = "<div class=\"e-otp-container d-flex justify-content-between\">\n  <input *ngFor=\"let item of otpArray; let i = index\"\n         #otpInput\n         type=\"text\"\n         maxlength=\"1\"\n         class=\"e-otp-box\"\n         [value]=\"otpArray[i]\"\n         (input)=\"onInput($event, i)\"\n         (keydown)=\"onKeyDown($event, i)\" />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/e-otp-input/e-otp-input.component.html
// module id = ../../../../../src/app/components/e-otp-input/e-otp-input.component.html
// module chunks = 3